import moment from "moment";
const conditions = {
    Invoice: function (row, dates) {
        return row.isInvoice;
    },
    Assignments: function (rows) {
        const hash = {};
        return rows.filter(row => {
            const item = row.assignmentId.toString() + row.userId.toString();
            const match = Boolean(hash[item]);
            return (match ? false : hash[item] = true);
        });
    },
    Taken: function (row, dates) {
        return row.totalBillings != 0 && dates.start <= moment.utc(row.dateTaken) && moment.utc(row.dateTaken) <= dates.end;
    },
    Referral: function (row) {
        return (row.developers + row.handlers) > 1 && row.totalBillings != 0;
    },
    Filled: function (row, dates) {
        return row.status === "F" &&
            row.totalBillings != 0 &&
            dates.start <= moment.utc(row.statusDate) &&
            moment.utc(row.statusDate) <= dates.end;
    },
    TeamingTaken: function (row, dates) {
        return this.Referral(row) && this.Taken(row, dates);
    },
    TeamingFilled: function (row, dates) {
        return this.Referral(row) && this.Filled(row, dates);
    },
    TimeToFill: function (row, dates) {
        return row.status === "F" &&
            dates.start <= moment.utc(row.statusDate) &&
            moment.utc(row.statusDate) <= dates.end;
    },
    Executive: function (row) {
        return row.searchType === "Executive";
    },
    Consulting: function (row) {
        return row.searchType === "Consulting" || row.searchType === "BLM";
    },
    IM: function (row) {
        return row.searchType === "IM";
    },
    Strategy: function (row) {
        return row.onStrategy;
    },
    StrategyTaken: function (row, dates) {
        return this.Strategy(row) && this.Taken(row, dates);
    },
    FilledJobValue: function (row, dates) {
        return this.Filled(row, dates) && row.excludeFromAverage == 0;
    }
};
export const financialCalculations = {
    GetTotalBillings: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Invoice(row, dates)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetTeamingValue: function (rows, dates) {
        rows = rows.filter(row => conditions.Referral(row) && conditions.Invoice(row, dates));
        rows = Array.from(new Set(rows.map(r => r.invoiceId))).map(invoiceId => rows.find(r => r.invoiceId == invoiceId));
        return rows.reduce((acc, row) => {
            return acc + row.amount;
        }, 0);
    },
    GetTeamingRevenue: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Referral(row) && conditions.Invoice(row, dates)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetTeamingTaken: function (rows, dates) {
        rows = conditions.Assignments(rows);
        return rows.reduce((acc, row) => {
            if (conditions.TeamingTaken(row, dates)) {
                return acc + (row.partnerBillingsUsd / row.totalBillingsUsd);
            }
            return acc;
        }, 0);
    },
    GetTeamingFilled: function (rows, dates) {
        rows = conditions.Assignments(rows);
        return rows.reduce((acc, row) => {
            if (conditions.TeamingFilled(row, dates)) {
                return acc + (row.partnerBillingsUsd / row.totalBillingsUsd);
            }
            return acc;
        }, 0);
    },
    GetAssignmentsTaken: function (rows, dates) {
        rows = conditions.Assignments(rows);
        return rows.reduce((acc, row) => {
            if (conditions.Taken(row, dates)) {
                return acc + (row.partnerBillingsUsd / row.totalBillingsUsd);
            }
            return acc;
        }, 0);
    },
    GetAssignmentsFilled: function (rows, dates) {
        rows = conditions.Assignments(rows);
        return rows.reduce((acc, row) => {
            if (conditions.Filled(row, dates)) {
                return acc + (row.partnerBillingsUsd / row.totalBillingsUsd);
            }
            return acc;
        }, 0);
    },
    GetTimeToFillSummary: function (rows, dates) {
        rows = conditions.Assignments(rows).filter(row => conditions.TimeToFill(row, dates));
        rows = Array.from(new Set(rows.map(r => r.assignmentId))).map(assignmentId => rows.find(r => r.assignmentId == assignmentId));
        const totalDays = rows.reduce((acc, row) => {
            const days = Math.abs(moment.utc(row.dateTaken).toDate().getTime() - moment.utc(row.statusDate).toDate().getTime()) / (1000 * 60 * 60 * 24);
            return acc + days;
        }, 0);
        return {
            totalDays: totalDays,
            count: rows.length
        };
    },
    GetTimeToFill: function (rows, dates) {
        const summary = this.GetTimeToFillSummary(rows, dates);
        return summary.totalDays / (summary.count || 1);
    },
    GetExecutive: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Executive(row) && conditions.Invoice(row, dates)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetConsulting: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Consulting(row) && conditions.Invoice(row, dates)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetIM: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.IM(row) && conditions.Invoice(row, dates)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetStrategyBillings: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Invoice(row, dates) && conditions.Strategy(row)) {
                return acc + row.invoiceTake;
            }
            return acc;
        }, 0);
    },
    GetStrategyTaken: function (rows, dates) {
        rows = conditions.Assignments(rows);
        return rows.reduce((acc, row) => {
            if (conditions.StrategyTaken(row, dates)) {
                return acc + (row.partnerBillingsUsd / row.totalBillingsUsd);
            }
            return acc;
        }, 0);
    },
    GetFilledJobValueSummary: function (rows, dates) {
        rows = conditions.Assignments(rows).filter(row => conditions.FilledJobValue(row, dates));
        rows = Array.from(new Set(rows.map(r => r.assignmentId))).map(assignmentId => rows.find(r => r.assignmentId == assignmentId));
        const total = rows.reduce((acc, row) => {
            return acc + row.totalBillings;
        }, 0);
        return {
            total: total,
            count: rows.length
        };
    },
    GetFilledJobValue: function (rows, dates) {
        const summary = this.GetFilledJobValueSummary(rows, dates);
        return summary.total / (summary.count || 1);
    },
    GetHeadcount: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Invoice(row, dates)) {
                return acc + row.amount * row.percentage / 100;
            }
        }, 0);
    },
    GetTaken: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Taken(row, dates)) {
                return acc + row.partnerBillingsUsd / row.totalBillingsUsd;
            }
        }, 0);
    },
    GetFilled: function (rows, dates) {
        return rows.reduce((acc, row) => {
            if (conditions.Filled(row, dates)) {
                return acc + row.partnerBillingsUsd / row.totalBillingsUsd;
            }
        }, 0);
    }
};
export function createFinancialCalculations(dates) {
    const methods = {};
    Object.keys(financialCalculations).forEach((name) => {
        const publicName = name[0].toLowerCase() + name.slice(1);
        methods[publicName] = (rows) => financialCalculations[name](rows, dates);
    });
    return methods;
}
